import React from 'react';

import ButtonFilled from '../../components/common/Buttons/ButtonFilled';
import ArInfoFlags from './ArInfoFlags';

import { FSNS_ACTION } from '../../utils/constants/arMeta';

const ArInfoActions = ({ onFsnsAction }) => {
    return (
        <div className="h-full p-8 overflow-scroll flex flex-col justify-start items-start">
            <h1 className="text-xl font-semibold text-black mb-6">Settings</h1>
            <hr className="w-full h-2" />
            <ArInfoFlags />

            <div className="flex flex-col justify-end mt-auto">
                <div className="flex flex-row gap-2 mt-4">
                    <ButtonFilled label="Go Live" color="green" onClick={() => onFsnsAction(FSNS_ACTION.GO_LIVE)} />
                    <ButtonFilled label="Reset" type="button" onClick={() => onFsnsAction(FSNS_ACTION.RESET)} />
                </div>
            </div>
        </div>
    );
};

export default React.memo(ArInfoActions);
